import axios from 'axios';
import React, { useEffect, useState } from 'react';
import SecurityHeaders from '../../context/SecurityHeaders';
import ENDPOINT from '../../context/EndPoint';
import { Link, useNavigate } from 'react-router-dom';
import { AccountCircle, Delete, Edit, MoreVert } from '@material-ui/icons';
import { Card, Badge, Button, Row, Col } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import { Dropdown } from 'react-bootstrap'
import SnackbarToast from '../../components/toasts/SnackbarToast';
import MentorItem from './MentorItem';
import AddMentor from './AddMentor';
import { useDispatch } from 'react-redux';
import { useActionsContext } from '../../context/ActionsContext';
import { useContext } from 'react'
import { AuthContext } from '../../context/AuthContext'






const Mentors = () => {
  const dispatch = useDispatch()

  const [mentors, setMentors] = useState([]);

  const [modelShow, setModelShow] = useState(false);
    const { rowsPerPage } = useActionsContext(); 
    const {user} = useContext(AuthContext)
    
  



  const getMentor = async () => {

    dispatch({ type: 'LOADING' })
    try {
      const formData = new FormData();
      formData.append("session", user.SessionId);
      formData.append("limit", rowsPerPage);
      const res = await axios.post("https://www.skillsuprise.com/fetch-mentors.php", formData, SecurityHeaders)
      if (res) {
        console.log(res.data)
        if (res.data.status === "success") {
          setMentors(res.data.mentors);
          dispatch({ type: 'DONE_LOADING' })

        }
        else {
          dispatch({ type: 'ERROR', payload: 'Error Occurred While Fetching' })
        }
      }
      else {
        dispatch({ type: 'ERROR', payload: 'Error Occurred While Fetching' })
      }
    }
    catch (error) {

      dispatch({ type: 'ERROR', payload: error.message })
    }
  }


  useEffect(() => {
    getMentor();
  }, [rowsPerPage])

  return (

    <>

      <div className="container mt-5">
        <div className="d-flex justify-content-center align-items-center">
          <h2>Our Top Mentors</h2>
        </div>

        <Link to='/add-mentor' className='btn btn-primary' >
          Add mentor
        </Link>

        <Row className="mt-3">
          {mentors ?
            <>
              {
                mentors.map((mentor,) => (
                  <MentorItem reload={getMentor} mentor={mentor} key={mentor.mentor_id} />
                ))}
            </> :
            <>

            </>}
        </Row>
      </div>
    </>
  );
};

export default Mentors;
